import {Component} from '@angular/core';

@Component({
  selector: 'detail-off-cell',
  template: `
    <ng-container>
      <div class="ap-crop-rotation-off-cell" title="{{'Info_NotValidGeom' | translate}}"></div>
    </ng-container>
  `,
  styles: [
    `
      .ap-crop-rotation-off-cell {
        height: 80%;
        width: 195px;
        margin: 8px;
        background: repeating-linear-gradient(-45deg, #cacaca, #cacaca 9px, #ffffff00 5px, #ffffff00 18px);
        cursor: not-allowed;
      }
    `,
  ]
})

export class DetailOffCellComponent {
}
